const clubRoutes = [
  {
    path: '/Club',
    component: () => import('./club.vue'),
    children: [
      {
        path: '/matrix/:clubName/:clubId',
        name: 'PointsMatrix',
        component: () => import('./matrix/viewMatrix.vue'),
        meta: {
          title: 'Points Matrix',
          requiresAuth: false,
          overrideStyle: true,
        },
      },
      {
        path: '/matrix/nexus/:clubName/:clubId',
        name: 'PointsMatrixPlayMorePass',
        component: () => import('./matrix/viewMatrix.vue'),
        meta: {
          title: 'Points Matrix',
          requiresAuth: false,
          overrideStyle: true,
          noLayout: true,
        },
      },
      {
        path: '/T&Cs/:clubName/:clubId',
        name: 'Terms and Conditions',
        component: () => import('./termsAndConditions/termsAndConditions.vue'),
        meta: {
          title: 'Terms & Conditions',
          requiresAuth: false,
          noLayout: true,
          overrideStyle: true,
        },
      },
      {
        path: ':clubid',
        component: () => import('./landing/landing.vue'),
        meta: {
          title: 'Membership Information',
          requiresAuth: false,
          noLayout: true,
          overrideStyle: false,
        },
      },
    ],
  },
];

export default clubRoutes;
